import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Home from './views/Home';
import About from './views/About';
import Projects from './views/Projects';
import Contact from './views/Contact';
import NoMatch from './views/NoMatch';
import Layout from './components/Layout';
import NewNav from './components/NewNav';
import Header from './components/Header';
import Footer from './components/Footer';

let logo = './images/logo.jpg';

const title = 'Drafting & Design'
const routes = [
    {
      title: 'Home',
      path: '/',
      component: Home,
      exact: true
    },
    {
      title: 'About Us',
      path: '/about',
      component: About
    },
    {
      title: 'Projects',
      path: '/projects',
      component: Projects
    },
    {
      title: 'Contact',
      path: '/contact',
      component: Contact
    }
]

const LogoWrapper = styled.div`
    position: absolute;
    top: 0;
    width: 300px;
    
    @media(max-width: 500px) {
      width: 280px;
    }

    img {
      max-width: 100%;
    }
`;

class App extends Component {
  handleLogoClick() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Router>
        <div className="app container-fluid" style={{padding: 0}}>
          <Helmet titleTemplate={`%s - ${title}`} />

          <Header>
              <div>
                <Link to={'/'} style={{flex: 1, paddingLeft: '15px', zIndex: 2, cursor: 'pointer'}}>
                    <LogoWrapper onClick={this.handleLogoClick}>
                        <img alt='CalMel Designs company logo' src={logo}/>
                    </LogoWrapper>
                </Link>
              </div>
              <div style={{flex: 2}}>
                <NewNav list={[
                    {title: 'Home', path:'/'},
                    {title: 'About Us', path:'/about'},
                    {title: 'Projects', path:'/projects'},
                    {title: 'Contact', path:'/contact'}
                ]} />
              </div>
          </Header>
          <div className="fixed-border-bottom-line"></div>
          
          <Layout>
            <Switch>
              {routes.map((route, i) => (
                <Route key={i} {...route} />
              ))}
              <Route component={NoMatch} />
            </Switch>
          </Layout>
          <Footer/>
        </div>
      </Router>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js